import { apiV1 } from '../lib/axios';

export async function getFeatures() {
  const response = await apiV1.get('/features');
  return response.data.features;
}
